import { immerable } from "immer";
import { ApiCloudFile, ApiProjectSupportingSignals, ApiProjectWorkPackageCost } from "avvir";

import addReadOnlyPropertiesToModel from "../../../services/utilities/mixins/add_read_only_properties_to_model";
import CloudFile from "../cloud_file";
import { QualityMetrics } from "../../../events/loaded/metrics/quality_metrics_loaded";

import type { ModifyPartial } from "type_aliases";

export type ProjectSummaryArgs = ModifyPartial<ProjectSummary, {
  model: CloudFile | ApiCloudFile
}>

export default class ProjectSummary {
  constructor({ firebaseId, model, projectAreaIds, selectedModelElementId, metrics, supportingSignals }: ProjectSummaryArgs = {}) {
    addReadOnlyPropertiesToModel(this, { firebaseId });
    this.projectAreaIds = projectAreaIds || [];
    this.selectedModelElementId = selectedModelElementId || null;

    if (model) {
      this.model = new CloudFile(model);
    }
    if (metrics) {
      this.metrics = metrics;
    }
    if (supportingSignals) {
      this.supportingSignals = supportingSignals;
    }
  }

  firebaseId: string;
  model?: CloudFile;
  projectAreaIds?: number[];
  selectedModelElementId?: number;
  highlightedModelElementId?: number;
  supportingSignals?: ApiProjectSupportingSignals;
  metrics: {
    quality: QualityMetrics,
    cost: CostMetrics
  } = {
    quality: {
      byArea: {},
      byTrade: {}
    },
    cost: {
      projectCapturedTotal: 0,
      projectEstimatedTotal: 0,
      projectModeledTotal: 0,
      projectWorkPackageCosts: []
    }
  };

  static readonly [immerable] = true;
}

export class CostMetrics {
  constructor({ projectCapturedTotal, projectEstimatedTotal, projectWorkPackageCosts, projectModeledTotal }) {
    this.projectCapturedTotal = projectCapturedTotal;
    this.projectEstimatedTotal = projectEstimatedTotal;
    this.projectWorkPackageCosts = projectWorkPackageCosts;
    this.projectModeledTotal = projectModeledTotal;
  }

  projectCapturedTotal: number;
  projectEstimatedTotal: number;
  projectModeledTotal: number;
  projectWorkPackageCosts: ApiProjectWorkPackageCost[];
}
